// extracted by mini-css-extract-plugin
export default {"loaderIcon":"NudgeAsigneeDetailsModal_loaderIcon__v3pMn","buttonRow":"NudgeAsigneeDetailsModal_buttonRow__mCBqs","assingedHeading":"NudgeAsigneeDetailsModal_assingedHeading__Fsvb4"};